module.exports = __webpack_public_path__ + "img/BB.c954e0e6.svg";